import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../style/header.css";
import logoImg from "../assets/logo.png";

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false);

  const routes = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    // { path: "/services", label: "Services" },
    { path: "/our-doctors", label: "Doctors" },
    { path: "/gallery", label: "Gallery" },
    { path: "/services", label: "Services" },
    { path: "/contact-us", label: "Contact" },
  ];

  return (
    <header className="navbar-container">
      <div className="container">
        <div className="header-je">
      <div className="navbar-left">
        <NavLink to="/" onClick={() => setMenuActive(false)}>
          <img src={logoImg} alt="Hospital Logo" className="navbar-logo" />
        </NavLink>
      </div>

      {/* Hamburger toggle for mobile */}
      <div className="navbar-toggle" onClick={() => setMenuActive(prev => !prev)}>
        ☰
      </div>

      <nav className={`navbar-menu ${menuActive ? "active" : ""}`}>
        {routes.map(({ path, label }) => (
          <NavLink
            key={path}
            to={path}
            onClick={() => setMenuActive(false)}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            {label}
          </NavLink>
        ))}
      </nav>
      </div>
      </div>
    </header>
  );
};

export default Navbar;
